import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers } from 'recompose';

import { updateUser } from 'modules/session/actions/updateUser';
import { getSessionInfo } from 'modules/session/actions/getSessionInfo';
import { sessionInitialized } from 'modules/appointmentsManagement/selectors/contracts';
import { fetchOrganizationConfig } from 'modules/common/actions/fetchOrganizationConfig';
import { fetchOrganizationLogo } from 'modules/auth/actions/fetchOrganizationLogo';
import { startObserveCurrentAppointmentUpdates } from 'modules/appointmentsManagement/actions/updateAppointment';
import { checkExternalInitialization } from 'shared/utils/externalLoginUtils';
import isMobile from 'shared/utils/checkMobileDevice';

import EditAppointmentPage from './EditAppointmentPage';

const mapStateToProps = (state) => ({
  sessionRequestStatus: state.session.sessionInfo.requestStatus,
  sessionInitialized: sessionInitialized(state),
  isExternalInit: checkExternalInitialization(),
});

export default compose(
  connect(
    mapStateToProps,
    {
      updateUser,
      getSessionInfo,
      fetchOrganizationConfig,
      startObserveCurrentAppointmentUpdates,
      fetchOrganizationLogo,
    },
  ),

  withStateHandlers({ screenHeight: '100%' }, {
    setMobileState: () => () => ({ screenHeight: document.getElementById('rootPage').clientHeight }),
  }),

  lifecycle({
    componentDidMount() {
      const {
        isExternalInit,
        sessionInitialized,
        getSessionInfo,
        updateUser,
        fetchOrganizationConfig,
        startObserveCurrentAppointmentUpdates,
        location: { search: searchParams },
        setMobileState,
        fetchOrganizationLogo,
      } = this.props;
      if (!isExternalInit) return;

      if (isMobile()) setMobileState();

      const params = new URLSearchParams(searchParams);
      const token = params.get('token');
      if (token) localStorage.setItem('jwt', token);

      if (sessionInitialized && !token) return;

      getSessionInfo()
        .then(({ payload: { selectedOrganizationToken } }) => fetchOrganizationLogo(selectedOrganizationToken))
        .then(updateUser)
        .then(fetchOrganizationConfig)
        .then(startObserveCurrentAppointmentUpdates)
        .catch(() => {});
    },
  }),
)(EditAppointmentPage);
